"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/DocumentCard/index"), exports);
//# sourceMappingURL=DocumentCard.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/DocumentCard.js
// module id = 1430
// module chunks = 0